import axios from 'axios'
// import router from '@/router/'
import { Cache } from '@/util/cache'
import { Tool } from '@/util/tool'
import DataType from '@/util/dataType'

const tool = new Tool()
const cache = new Cache()
const errorResultCode = [
  DataType.AjaxResultCodeEnum.FAILURE_USER_INFO_INVALID.value,
  DataType.AjaxResultCodeEnum.INVALID_USER_INFORMATION.value,
  DataType.AjaxResultCodeEnum.GET_ACCOUNT_FAILURE_OAUTH_KEY_DOES_NOT_EXISTS.value,
  DataType.AjaxResultCodeEnum.GET_AUTHORIZATION_FAILURE_OAUTH_KEY_DOES_NOT_EXISTS.value
]
const http = axios.create({
  timeout: 1000 * 150
})
window._axiosPromiseArr = []
window._requestCount = 0
const ajax = {
  get (url, input, success, failure, config) {
    return axios.get(url, { params: input, requestConfig: config }).then((result) => {
      return resultHandler(result, Promise.resolve, Promise.reject, success, failure)
    })
  },
  post (url, input, success, failure, config) {
    return axios.post(url, input, { requestConfig: config }).then((result) => {
      return resultHandler(result, Promise.resolve, Promise.reject, success, failure)
    })
  },
  put (url, input, success, failure, config) {
    return axios.put(url, input, { requestConfig: config }).then((result) => {
      return resultHandler(result, Promise.resolve, Promise.reject, success, failure)
    })
  },
  delete (url, input, success, failure, config) {
    return axios.delete(url, { params: input, requestConfig: config }).then((result) => {
      return resultHandler(result, Promise.resolve, Promise.reject, success, failure)
    })
  },
  postHeader (url, input, success, failure, config) {
    return axios.post(url, input, config).then((result) => {
      return resultHandler(result, Promise.resolve, Promise.reject, success, failure)
    })
  }
}

axios.interceptors.request.use(
  config => {
    const accessToken = cache.getItem('Access-Token')
    if (tool.isNotEmpty(accessToken)) {
      config.headers.common['Access-Token'] = accessToken
    }
    pushRequest(config)
    return config
  },
  error => {
    return Promise.reject(error).catch((e) => {})
  }
)

axios.interceptors.response.use(
  response => {
    popRequest()
    if (tool.isNotEmpty(response) && response.status === 200 && errorResultCode.includes(response.data.code)) {
      switch (process.env.NODE_ENV) {
        case 'develop':
          window.open('https://pandaria.sztcu.com/#/', '_self')
          break
        case 'production':
          window.open('https://pandaria.sztus.com/#/', '_self')
          break
        case 'training':
          window.open('https://pandaria.sztnh.com/#/', '_self')
          break
      }
      return Promise.reject(new Error('')).catch((e) => {})
    }
    return response
  },
  error => {
    popRequest()
    return Promise.reject(error).catch((e) => {})
  }
)

function resultHandler (result, resolve, reject, success, failure) {
  if (tool.isNotEmpty(result)) {
    const resultData = result.data

    if (result.status === 200) {
      if (resultData.code < 0) {
        if (failure) {
          failure(resultData)
        }

        return Promise.reject(result.data).catch(function (reason) {
        })
      } else {
        if (success) {
          success(resultData.data)
        }

        return Promise.resolve(resultData.data)
      }
    } else {
      if (failure) {
        failure(resultData)
      }

      return Promise.reject(result.statusText)
    }
  } else {
    return Promise.reject(new Error('')).catch((e) => {})
  }
}

function pushRequest (config) {
  const requestConfig = config.requestConfig
  const showLoading = tool.isNotEmpty(requestConfig) ? (tool.isNotEmpty(requestConfig.showLoading) ? requestConfig.showLoading : false) : false
  const couldCancel = tool.isNotEmpty(requestConfig) ? (tool.isNotEmpty(requestConfig.couldCancel) ? requestConfig.couldCancel : true) : true
  if (couldCancel) {
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel })
    })
  }
  if (showLoading) {
    window._requestCount++
    window._requestCount > 0 && window._VMA.$eventBus.$emit('SHOW_PROGRESS_CIRCLE')
  }
}

function popRequest () {
  window._requestCount > 0 && window._requestCount--
  window._requestCount <= 0 && window._VMA.$eventBus.$emit('HIDE_PROGRESS_CIRCLE')
}

export { http, ajax }
